import { createFileRoute } from "@tanstack/react-router";
import { KontorPage, kontorHead } from "@/pages/KontorPage";

export const Route = createFileRoute("/de/branchen/bueros-hauptsitze")({
  head: () => kontorHead("de"),
  component: () => <KontorPage locale="de" />,
});
